import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.heading',
		defaultMessage: 'Upload a CSV file',
		description: 'Heading for upload screen',
	},
	headingExistingProject: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.heading-existing-project',
		defaultMessage: 'Import data into {projectName}',
		description: 'Import into existing project heading with project name',
	},
	descriptionExistingProject: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.description-existing-project',
		defaultMessage:
			"Let's bring your data into Jira. Before you begin, format your CSV to match the fields in your selected project using our <link>import documentation</link>.",
		description: 'Import into existing project Description with learn more link',
	},
});
